import HealthRaterPriceInsuredToSave from '@/modules/health/common/models/MID/HealthRaterPriceInsuredToSave'
import type ForeignHealthInsuranceType from '../ForeignHealthInsuranceType'
import RaterPriceClientProduct from '@/modules/common/common/models/MID/RaterPriceClientProduct'

export default class ForeignHealthRaterPriceRequest {
  /** Lista de productos del cliente. (Opcional). */
  clientProduct: RaterPriceClientProduct[]

  /** Línea de negocio. Ejemplo: "AV01". (Obligatorio, String). */
  businessLine: string

  /** Fecha de inicio de seguro. Ejemplo: "2024-09-24". (Obligatorio, DateTime). */
  insuranceStartDate: string

  /** Fecha de inicio de seguro. Ejemplo: "2024-09-24". (Obligatorio, DateTime). */
  insuranceEndDate: string

  /** Tipo de seguro. Ejemplo: "6". (Obligatorio, Integer) */
  insuranceType: ForeignHealthInsuranceType

  /** (String): Código postal del titular de la póliza. Ejemplo: "28041". Obligatorio para una primera tarificación. */
  policyHolderPostal!: string

  /** (Array): Listado de asegurados. */
  insureds!: HealthRaterPriceInsuredToSave[]

  /** Número de cotización. Ejemplo: "7747027". (Opcional, String). */
  quotationNumber: string | undefined

  /** Código de identificación de la cotización. Ejemplo: "27B3A7EA-876D-440D-9F53-3A16F7CD0226". (Opcional, GUID). */
  quotationId: string | undefined

  /** (String): Tipo de estancia en el extranjero. Ejemplo: "Trabajo / estudio". (Opcional) */
  stayAbroadType?: string

  /** (String, opcional): Código del mediador. */
  mediator?: string

  constructor(data: any) {
    this.clientProduct = data.clientProduct?.map((c: any) => new RaterPriceClientProduct(c))
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.insuranceEndDate = data.insuranceEndDate
    this.insuranceType = data.insuranceType
    this.policyHolderPostal = data.policyHolderPostal
    this.insureds = data.insureds?.map((i: any) => new HealthRaterPriceInsuredToSave(i))
    this.quotationNumber = data.quotationNumber
    this.quotationId = data.quotationId
    this.stayAbroadType = data.stayAbroadType
    if (data.mediator) this.mediator = data.mediator
  }
}
